import convertAnnotation from 'helpers/converters/convert-annotation';
import httpClient from '../../http-client';
import Annotation from '../../models/annotation';
import AnnotationFromResponse from '../../models/from-api/annotation';

const getAnnotations = async (filters?: Object): Promise<Annotation[]> => {
  const annotations = (
    await httpClient.get<AnnotationFromResponse[]>(`/annotations/`, {
      params: filters,
    })
  ).data;

  let convertedAnnotations = [] as Annotation[];
  if (annotations && annotations.length) {
    convertedAnnotations = annotations.map(convertAnnotation);
  }

  return convertedAnnotations;
};

const createAnnotation = async (
  newAnnotation: { title: string; description: string },
  contentId: string,
  trailId?: string,
) => {
  if (!newAnnotation) {
    throw new Error('Os dados para criação da anotação são obrigatórios');
  }

  const response = await httpClient({
    method: 'post',
    url: '/annotations',
    data: {
      trail_id: trailId,
      content_id: contentId,
      title: newAnnotation.title,
      description: newAnnotation.description,
    },
  });

  return response;
};

const deleteAnnotation = async (annotationId: string) => {
  if (!annotationId) {
    throw new Error('ID obrigatório para exclusão!');
  }

  const response = await httpClient({
    method: 'delete',
    url: `/annotations/${annotationId}`,
  });

  return response;
};

const updateAnnotation = async (
  annotationId: string,
  newAnnotation: Annotation,
) => {
  if (!annotationId) {
    throw new Error('ID obrigatório para edição de anotação!');
  }

  if (!newAnnotation) {
    throw new Error('Dados para edição não encontrados!');
  }

  const response = await httpClient({
    method: 'put',
    url: `/annotations/${annotationId}`,
    data: {
      title: newAnnotation.title,
      description: newAnnotation.description,
    },
  });

  return response;
};

export { getAnnotations, createAnnotation, deleteAnnotation, updateAnnotation };
